var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,3.7c-0.7-0.3-3.3-1.4-7.1-1.4S5.6,3.3,4.9,3.7C4.2,4,3.8,4.6,3.8,5.4v5.6c0,5.8,7.4,9.8,7.7,10 c0.1,0.1,0.4,0.2,0.5,0.2s0.4-0.1,0.5-0.2c0.3-0.1,7.7-4.1,7.7-10V5.4C20.2,4.6,19.8,4,19.1,3.7z M17,8.2l-5,5.7 c-0.3,0.3-0.8,0.4-1.1,0l-2.4-2.6c-0.2-0.1-0.2-0.4,0-0.5l0.4-0.4c0.1-0.2,0.3-0.2,0.4-0.1l1.9,1L16,7.1c0.2-0.2,0.4-0.2,0.5,0 L17,7.6C17.2,7.8,17.2,8,17,8.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnify);
export default ForwardRef;